import { render, staticRenderFns } from "./DocumentShare.vue?vue&type=template&id=46f7e91d"
import script from "./DocumentShare.vue?vue&type=script&lang=js"
export * from "./DocumentShare.vue?vue&type=script&lang=js"
import style0 from "./DocumentShare.vue?vue&type=style&index=0&id=46f7e91d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports